import { useState, useEffect } from 'react';
import { getCompareData } from '@base/product/services';
import { baseRows } from '@base/product/ProdCompare/config';
import {
    ICompareRes,
    ICompareData,
    IRow,
    ICompareInstance,
} from 'base/interfaces/product-compare';

export const transCompareData = (res: ICompareRes): ICompareData | undefined => {
    const { attributes, compareVariantInfo } = res;
    // 对比商品少于两个时不显示
    if (compareVariantInfo.length < 2) {
        return;
    }
    const attrRows: IRow[] = attributes.map(attr => ({
        type: 'text',
        id: attr.attributeId,
        name: attr.name,
    }));
    return {
        rows: [...baseRows, ...attrRows],
        products: compareVariantInfo
    }
};

const useCompare = (variantId?: string): ICompareInstance | undefined => {
    const [data, setData] = useState<ICompareData | undefined>();

    const getData = async (variantId: string) => {
        try {
            const res = await getCompareData(variantId);
            const data = transCompareData(res);
            setData(data);
        } catch (e) {
            setData(void 0);
        }
    };

    useEffect(() => {
        setData(void 0);
        variantId && getData(variantId);
    }, [variantId]);

    return data;
};

export default useCompare;